import { PendingWorkService } from '../services/pending-work/pending-work.service';
import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

export const pendingWorkInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const pendingWorkService = inject(PendingWorkService);

  /**
   * Pass an excluded request straight through
   *
   * Perpetual traffic — polling, health checks — would keep the counter
   * above zero forever and settled() would never resolve.
   */
  if (req.context.get(pendingWorkService.exclude)) {
    // Forward the request without counting it
    return next(req);
  }

  // Count the request for as long as it is in flight
  pendingWorkService.httpCounter.begin();
  return next(req).pipe(finalize(() => pendingWorkService.httpCounter.end()));
};
